<template>
  <div class="white ma-2 pa-5 d-flex flex-column rounded-lg">
    <h2 class="mt-n2 text-center">Terms of Service</h2>
    <div style="font-size: 16px;" class="mt-5">
      <p>
        We've changed our terms of service.
      </p>
      <p>
        By checking the box below, I acknowledge that I have <strong>read</strong> and <strong>agree</strong> to the terms of the PartnerLists <router-link :to="{'name': 'login/tos'}">Pro EULA</router-link> and our <router-link :to="{'name': 'login/privacy'}">Pro App Privacy Policy</router-link>.
      </p>
    </div>
    <v-form ref="form" @submit.prevent="acceptClick">
      <div class="d-flex flex-column align-center mt-n2">
        <v-checkbox v-model="accepted"
          label="I have read and agree."
          :rules="[required]"
          hide-details="true"
        />  
        <v-btn width="60%" type="submit" color="primary" class="mt-4">Continue</v-btn>
      </div>
    </v-form>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex'
import { required } from '@/lib/validations'

export default {
  name: 'LoginAccept',

  props: ['user_id', 'acceptance_token'],

  data() {
    return {
      accepted: false,

      // validation rules
      required,
    }
  },

  computed: {
    ...mapGetters('auth', ['acceptanceKeys']),
  },

  methods: {
    ...mapActions('auth', ['acceptAgreement']),

    async acceptClick() {
      if (this.$refs.form.validate()) {
        const result = await this.acceptAgreement(this.acceptanceKeys)
        if (result.ok) {
          this.$router.push({ name: 'home' })
        } else {
          this.$router.push({ name: 'login' })
        }
      }
    },
  },
}
</script>
